import * as actionTypes from './MFACodeActionTypes';
import * as serviceEndPoint from '../../../../SharedModule/Service/service';
import axios from 'axios';

export const GenerateOtp = (value) => {

  return dispatch => {
    return axios.post(`${serviceEndPoint.GENERATE_OTP}`, value)
      .then(response => {
        dispatch(GenerateOtpResponse(response.data));
      })
      .catch(error => {
        dispatch(GenerateOtpResponse({ systemFailure: true }));
      });
  };
};
export const GenerateOtpResponse = (otpResponse) => {

  return ({
    type: actionTypes.GENERATE_OTP,
    otpResponse: otpResponse
  });
};

export const ValidateOtpCode = (value) => {

  return dispatch => {
    return axios.post(`${serviceEndPoint.VALIDATE_OTP}`, value)
      .then(response => {
        dispatch(ValidateOtpResponse(response.data));
      })
      .catch(error => {
        dispatch(ValidateOtpResponse({ systemFailure: true }));
      });
  };
};

export const ValidateOtpResponse = (validateOtpResponse) => {

  return ({
    type: actionTypes.VALIDATE_OTP,
    validateOtpResponse: validateOtpResponse
  });
};

export const ValidateOtpCount = () => {
  
  return ({
    type: actionTypes.VALIDATE_OTP_COUNT,
  });
};

export const ResetOtpCount = () => {
  
  return ({
    type: actionTypes.VALIDATE_OTP_COUNT_RESET,
  });
};


